import React from 'react';
import PropTypes from 'prop-types';
import 'src/components/Search/FormSend.scss';

import Magnify from '@mdi/svg/svg/magnify.svg';

const FormSend = ({ analyticsActions }) => {
  const searchButtonText = 'Szukaj';
  return (
    <button
      data-test="form-submit"
      onClick={() => {
        analyticsActions.sendSearchClick();
        analyticsActions.sendEventClick('search');
      }}
      styleName="form-send__element"
      type="submit"
    >
      <Magnify viewBox="0 0 24 24" /> {searchButtonText}
      <span styleName="form-send__element-ripple" />
    </button>
  );
};

FormSend.propTypes = {
  analyticsActions: PropTypes.shape({
    sendSearchClick: PropTypes.func,
    sendEventClick: PropTypes.func,
  }),
};

FormSend.defaultProps = {
  analyticsActions: {
    sendSearchClick: () => {},
    sendEventClick: () => {},
  },
};

export default FormSend;
